import React from 'react';
import { useAnalytics } from '../hooks/useAnalytics';

// Wrapper component that initializes analytics
const AnalyticsWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Initialize analytics once when component mounts
  useAnalytics();
  
  // Just render children - no additional UI
  return <>{children}</>;
};

export default AnalyticsWrapper;
